module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PF-6db06cba8184405914d695bc89f9c92b.png";